module.exports = __webpack_public_path__ + "static/media/2903d33b.jpg";